import { Link } from "react-router-dom";
import LegalDoc, { LegalSection, LegalList } from "@/components/LegalDoc";

const DonationTerms = () => (
  <LegalDoc title="Donation Terms" updated="October 1st, 2026">
    <p className="text-base text-ink/80 leading-relaxed">
      These terms apply to every donation made through aimgame.org, whether by card, UPI, net banking,
      bank transfer or cheque. By donating, you agree to them.
    </p>

    <LegalSection title="Who receives your donation">
      <p>
        AimGame is the flagship program of Responsible Charity Society. All donations are received by
        Responsible Charity Society, the registered Indian NGO, and receipts are issued in its name.
        Cheques and bank transfers must be made out to Responsible Charity Society.
      </p>
    </LegalSection>

    <LegalSection title="Donation amounts">
      <p>
        Donations to Responsible Charity Society start at ₹5,000. Suggested amounts are ₹5,000, ₹10,000,
        ₹15,000, ₹25,000, ₹35,000, ₹50,000, ₹75,000 and ₹1,00,000. Online payments are accepted up to
        ₹1,00,000. Larger gifts are arranged through our Giving Desk and received by bank transfer. All
        amounts are in Indian Rupees (INR), and no fee is added to your gift.
      </p>
    </LegalSection>

    <LegalSection title="Terms of giving">
      <LegalList
        items={[
          "We do not accept cash donations.",
          "We accept donations only in Indian Rupees (INR), from within India. Bank transfers and direct deposits are accepted from domestic Indian bank accounts only. We do not accept international transfers.",
          "We accept gifts only with the donor's full name, address and PAN No.",
          "Card, UPI and net-banking payments are processed securely by Razorpay. We do not see or store your card or UPI details.",
          "Donations are voluntary gifts that support AimGame scholarships and the services that come with them: education, healthcare and employment assistance.",
        ]}
      />
    </LegalSection>

    <LegalSection id="tax" title="Tax benefit and receipts">
      <p>
        Donations are eligible for deduction under Section 80G of the Income Tax Act, 1961 (80G Reg.
        No. AABAR6353DE2021701, valid From AY 2022-23 to AY 2026-2027). A receipt is issued for every
        gift and emailed to the address you provide. A Form 10BE certificate follows once our annual
        statement is filed, and you can use it to claim your Section 80G deduction.
      </p>
    </LegalSection>

    <LegalSection title="Why we ask for your details">
      <p>
        Indian tax law requires us to record who every donation comes from and to report each donor's
        PAN No. every year. A donation we can't link to a named donor can be taxed heavily, which would
        take money away from our students. This applies to every way of giving, including UPI and bank
        transfers. We use your details only for receipts and legal reporting, and we keep them secure.
      </p>
      <p>
        So we accept gifts only with your full name, address and PAN No. See our{" "}
        <Link to="/privacy-policy" className="font-bold text-flame hover:text-flame-dark transition-colors">
          Privacy Policy
        </Link>{" "}
        for how we protect your information.
      </p>
    </LegalSection>

    <LegalSection title="Giving by bank transfer or cheque">
      <p>
        To give by bank transfer or cheque, request our details through the form on the{" "}
        <Link to="/donate" className="font-bold text-flame hover:text-flame-dark transition-colors">
          Donate page
        </Link>
        . We email the account details with a reference code. After you transfer, tell us your amount,
        date and transaction reference, or email them to donations@responsiblecharity.org. Cheques must
        be made out to Responsible Charity Society. Transfers are accepted from domestic Indian bank
        accounts only, and we do not accept international transfers. Our account details are not
        published on this website.
      </p>
    </LegalSection>

    <LegalSection title="Cancellation and refunds">
      <p>
        Donations are voluntary gifts and are non-refundable. Once a payment is completed, it cannot be
        cancelled. The only exceptions are:
      </p>
      <LegalList
        items={[
          "a duplicate or mistaken payment, reported within three days of the payment; and",
          "a gift we cannot record because full donor details are missing, which is returned to the source account.",
        ]}
      />
      <p>
        To report a duplicate or mistaken payment, email donations@responsiblecharity.org within three
        days with your full name, the amount, the date and the transaction reference. Approved refunds
        go back to the original payment source, and your bank may take several working days to show them.
      </p>
      <p>
        If a payment fails or you do not receive a confirmation, please do not pay again. Check your
        bank statement first, and if the amount was debited, write to us with the transaction reference
        and we will help.
      </p>
    </LegalSection>

    <LegalSection title="Shipping">
      <p>
        Responsible Charity Society does not ship physical goods. Your donation receipt is emailed after
        your payment is confirmed. If you do not receive it, email donations@responsiblecharity.org.
      </p>
    </LegalSection>

    <LegalSection title="CSR registration">
      <p>
        Responsible Charity Society is registered to undertake CSR activities (CSR Registration No.
        CSR00050572). Companies can start a conversation on our{" "}
        <Link to="/csr" className="font-bold text-flame hover:text-flame-dark transition-colors">
          CSR Partners page
        </Link>
        .
      </p>
    </LegalSection>

    <LegalSection title="Contact">
      <p>
        Questions about a donation: donations@responsiblecharity.org. Responsible Charity Society, 22
        Shaktigarh, Jadavpur, Kolkata, West Bengal 700032, Phone: 03340048442
      </p>
    </LegalSection>
  </LegalDoc>
);

export default DonationTerms;
